import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4a100db1d70edbfb4b907359f1802fe1.jpg"
          alt="Vertical Farming"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <div className={`max-w-3xl ${isRTL ? 'mr-0' : 'ml-0'}`}>
            <h1 className="font-almarai font-bold text-5xl md:text-6xl lg:text-7xl text-white leading-tight mb-8">
              {t('hero.title')}
            </h1>
            <p className="font-tajawal text-xl md:text-2xl text-white/90 mb-12 leading-relaxed">
              {t('hero.subtitle')}
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollToSection('services')}
                className="bg-primary text-white px-8 py-4 rounded-full font-tajawal text-base hover:bg-primary-dark transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg"
              >
                {t('hero.cta1')}
                <i className={`ri-arrow-${isRTL ? 'left' : 'right'}-line`}></i>
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-tajawal text-base hover:bg-white hover:text-primary transition-all whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta2')}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
};

export default HeroSection;